import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="mx-auto flex w-full max-w-[1280px] flex-col items-center px-4 py-24 text-center md:px-6">
      <p className="text-6xl font-bold text-primary-500 md:text-8xl">404</p>
      <h1 className="mt-4 text-xl font-bold text-foreground-950 md:text-2xl">页面不存在</h1>
      <p className="mt-2 max-w-md text-sm leading-relaxed text-foreground-500">
        你访问的页面可能已被移除或链接有误，不妨回到首页，继续发现精彩影视作品与娱乐资讯。
      </p>
      <div className="mt-8 flex flex-wrap justify-center gap-3">
        <Link
          to="/"
          className="cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
        >
          返回首页
        </Link>
        <Link
          to="/news"
          className="cursor-pointer whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-600"
        >
          浏览资讯
        </Link>
      </div>
    </div>
  );
}